export const DEFAULT_MESSAGE_CREATED_CONDITION = [
  {
    attribute_key: 'message_type',
    filter_operator: 'equal_to',
    values: '',
    query_operator: 'and',
    custom_attribute_type: '',
  },
];

export const DEFAULT_CONVERSATION_CONDITION = [
  {
    attribute_key: 'browser_language',
    filter_operator: 'equal_to',
    values: '',
    query_operator: 'and',
    custom_attribute_type: '',
  },
];

export const DEFAULT_CONVERSATION_REOPENED_CONDITION = [
  {
    attribute_key: 'inbox_id',
    filter_operator: 'equal_to',
    values: '',
    query_operator: 'and',
    custom_attribute_type: '',
  },
];

export const DEFAULT_SEND_MESSAGE_ACTION = [
  {
    action_name: 'send_message',
    action_params: [],
  },
];

export const DEFAULT_OTHER_CONDITION = [
  {
    attribute_key: 'status',
    filter_operator: 'equal_to',
    values: '',
    query_operator: 'and',
    custom_attribute_type: '',
  },
];

export const DEFAULT_ACTIONS = [
  {
    action_name: 'assign_agent',
    action_params: [],
  },
];

export const MESSAGE_CONDITION_VALUES = [
  {
    id: 'incoming',
    name: 'Mensagem recebida',
    i18nKey: 'INCOMING',
  },
  {
    id: 'outgoing',
    name: 'Mensagem de saída',
    i18nKey: 'OUTGOING',
  },
];

export const PRIORITY_CONDITION_VALUES = [
  {
    id: 'nil',
    name: 'Nenhuma',
    i18nKey: 'NONE',
  },
  {
    id: 'low',
    name: 'Baixa',
    i18nKey: 'LOW',
  },
  {
    id: 'medium',
    name: 'Média',
    i18nKey: 'MEDIUM',
  },
  {
    id: 'high',
    name: 'Alta',
    i18nKey: 'HIGH',
  },
  {
    id: 'urgent',
    name: 'Urgente',
    i18nKey: 'URGENT',
  },
];
